import { useMutation } from "@apollo/client";
import { INIT_RESOURCE_VERSION_PREVIEW } from "../../graphql/mutations";

// eslint-disable-next-line import/prefer-default-export
export const useInitializeFilePreview = ({ onError, onSuccess }) => {
  const [initializeFilePreview, { loading: initializing }] = useMutation(INIT_RESOURCE_VERSION_PREVIEW);

  const onHandleInitializeFilePreview = async ({ resourceId, versionNumber }) => {
    const variables = {
      resourceId,
      versionNumber,
    };

    let url;

    try {
      const res = await initializeFilePreview({ variables });
      url = res?.data?.initResourceVersionPreview;
    } catch {
      handleError();
    }

    if (url) {
      handleSuccess(url);
    }
  };

  function handleError(errorResult) {
    typeof onError === "function"
      ? onError(errorResult)
      : console.warn("Missing 'onError' function.");
  }

  function handleSuccess(url) {
    typeof onSuccess === "function"
      ? onSuccess(url)
      : console.warn("Missing 'onSuccess' function.");
  }

  return [onHandleInitializeFilePreview, { initializing }];
};
